const languages = {
  zh: {
    label: '中文',
    href: '/language-resource/#chinese'
  },
  ht: {
    label: 'Kreyòl',
    href: '/language-resource/#creole'
  },
  fr: {
    label: 'Français',
    href: '/language-resource/#french'
  },
  de: {
    label: 'Deutsch',
    href: '/language-resource/#german'
  },
  gu: {
    label: 'ગુજરાતી',
    href: '/language-resource/#gujarati'
  },
  hi: {
    label: 'हिंदी',
    href: '/language-resource/#hindi'
  },
  it: {
    label: 'Italiano',
    href: '/language-resource/#italian'
  },
  ja: {
    label: '日本語',
    href: '/language-resource/#japanese'
  },
  ko: {
    label: '한국어',
    href: '/language-resource/#korean'
  },
  pl: {
    label: 'Polski',
    href: '/language-resource/#polish'
  },
  pt: {
    label: 'Português',
    href: '/language-resource/#portuguese'
  },
  ru: {
    label: 'Русский',
    href: '/language-resource/#russian'
  },
  es: {
    label: 'Español',
    href: '/language-resource/#spanish'
  },
  tl: {
    label: 'Tagalog',
    href: '/language-resource/#tagalog'
  },
  vi: {
    label: 'Tiếng Việt',
    href: '/language-resource/#vietnamese'
  }
};
export default languages;